import { useEffect } from "react";

/**
 * useCustomCursor
 * Cursor personalizado desktop only.
 * Se desactiva automáticamente en mobile/tablet.
 */
export function useCustomCursor() {
  useEffect(() => {
    /* ── Detect mobile / touch devices ── */
    const isMobile =
      window.innerWidth <= 1024 ||
      "ontouchstart" in window ||
      navigator.maxTouchPoints > 0;

    const cursor = document.getElementById("custom-cursor");
    const ring = document.getElementById(
      "custom-cursor-ring"
    );

    if (!cursor || !ring) return;

    /* ── Hide cursor elements on mobile ── */
    if (isMobile) {
      cursor.style.display = "none";
      ring.style.display = "none";
      return;
    }

    /* ── Show on desktop ── */
    cursor.style.display = "block";
    ring.style.display = "block";

    let mouseX = 0;
    let mouseY = 0;

    let ringX = 0;
    let ringY = 0;

    let rafId;

    /* ── Mouse move ── */
    const onMove = (e) => {
      mouseX = e.clientX;
      mouseY = e.clientY;

      cursor.style.left = mouseX + "px";
      cursor.style.top = mouseY + "px";
    };

    /* ── Ring animation ── */
    const animateRing = () => {
      ringX += (mouseX - ringX) * 0.12;
      ringY += (mouseY - ringY) * 0.12;

      ring.style.left = ringX + "px";
      ring.style.top = ringY + "px";

      rafId = requestAnimationFrame(
        animateRing
      );
    };

    /* ── Grow effect ── */
    const grow = () => {
      cursor.style.width = "20px";
      cursor.style.height = "20px";

      ring.style.width = "60px";
      ring.style.height = "60px";

      ring.style.borderColor =
        "rgba(201,151,58,0.6)";
    };

    /* ── Shrink effect ── */
    const shrink = () => {
      cursor.style.width = "12px";
      cursor.style.height = "12px";

      ring.style.width = "36px";
      ring.style.height = "36px";

      ring.style.borderColor =
        "rgba(201,151,58,0.5)";
    };

    /* ── Add hover listeners ── */
    const addHoverListeners = () => {
      document
        .querySelectorAll(
          "a, button, [data-cursor-grow]"
        )
        .forEach((el) => {
          el.removeEventListener(
            "mouseenter",
            grow
          );

          el.removeEventListener(
            "mouseleave",
            shrink
          );

          el.addEventListener(
            "mouseenter",
            grow
          );

          el.addEventListener(
            "mouseleave",
            shrink
          );
        });
    };

    /* ── Init ── */
    document.addEventListener(
      "mousemove",
      onMove
    );

    rafId = requestAnimationFrame(
      animateRing
    );

    addHoverListeners();

    /* ── Observe DOM changes ── */
    const mo = new MutationObserver(() => {
      addHoverListeners();
    });

    mo.observe(document.body, {
      childList: true,
      subtree: true,
    });

    /* ── Cleanup ── */
    return () => {
      document.removeEventListener(
        "mousemove",
        onMove
      );

      cancelAnimationFrame(rafId);

      mo.disconnect();
    };
  }, []);
}
